import requestUtil from "../../helpers/requestUtil";
import {
  setEmailApproachDropdownLists,
  setEmailPageDetails,
  setErrorMessage,
  setLoadingFlagDecrement,
  setLoadingFlagIncrement,
  setSuccessMessage,
} from "./slice";

// Email Approach dropdown list
export function getEmailApproachDropdownList(url) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(
        `${url}/Dropdown/get-messagesending-source`,
        "GET"
      );
      dispatch(setEmailApproachDropdownLists(response));
      dispatch(setSuccessMessage(response.message));
    } catch (error) {
      dispatch(setErrorMessage(error.message));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

// Email Setup page get a details
export function getEmailPageDetails(url) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(
        `${url}/SmtpEmailSettings/get-smtpemail-setting`,
        "GET"
      );
      const params = {
        emailApproach: response.messageSendingSource,
        emailServer: response.smtpServerHost,
        commonEmail: response.smtpLogin,
        password: response.smtpPassword,
        displayName : response.displayName,
        dnsText: response.dnsText
      };
      dispatch(setEmailPageDetails(params));
      dispatch(setSuccessMessage(response.message));
    } catch (error) {
      dispatch(setErrorMessage(error.message));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

// Email page setup save method
export function saveEmailSetup(url, params) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(
        `${url}/SmtpEmailSettings/save-smtpemail-setting`,
        "POST",
        params
      );
      dispatch(setSuccessMessage(response.message));
    } catch (error) {
      dispatch(setErrorMessage(error.message));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}
